import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import blogReducer from './blogs';
import commentsReducer from './comments';

export default combineReducers({
    blogReducer,
    commentsReducer,
    routing: routerReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js